var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBenefitRiskManagement3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14941 7.99072V-0.00927734H5.64941V7.99072C5.64941 8.72007 5.35968 9.41954 4.84396 9.93527C4.32823 10.451 3.62876 10.7407 2.89941 10.7407C2.17007 10.7407 1.4706 10.451 0.95487 9.93527C0.439145 9.41954 0.149414 8.72007 0.149414 7.99072V6.99072C0.149414 6.79181 0.228432 6.60104 0.369084 6.46039C0.509736 6.31974 0.700502 6.24072 0.899414 6.24072C1.09833 6.24072 1.28909 6.31974 1.42974 6.46039C1.5704 6.60104 1.64941 6.79181 1.64941 6.99072V7.99072C1.64941 8.32224 1.78111 8.64019 2.01553 8.87461C2.24995 9.10903 2.56789 9.24072 2.89941 9.24072C3.23093 9.24072 3.54888 9.10903 3.7833 8.87461C4.01772 8.64019 4.14941 8.32224 4.14941 7.99072Z",
    fill: "url(#paint0_linear_3443_12539)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14941 7.99072V-0.00927734H5.64941V7.99072C5.64941 8.72007 5.35968 9.41954 4.84396 9.93527C4.32823 10.451 3.62876 10.7407 2.89941 10.7407C2.17007 10.7407 1.4706 10.451 0.95487 9.93527C0.439145 9.41954 0.149414 8.72007 0.149414 7.99072V6.99072C0.149414 6.79181 0.228432 6.60104 0.369084 6.46039C0.509736 6.31974 0.700502 6.24072 0.899414 6.24072C1.09833 6.24072 1.28909 6.31974 1.42974 6.46039C1.5704 6.60104 1.64941 6.79181 1.64941 6.99072V7.99072C1.64941 8.32224 1.78111 8.64019 2.01553 8.87461C2.24995 9.10903 2.56789 9.24072 2.89941 9.24072C3.23093 9.24072 3.54888 9.10903 3.7833 8.87461C4.01772 8.64019 4.14941 8.32224 4.14941 7.99072Z",
    fill: "white",
    fillOpacity: 0.17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3443_12539",
    x1: 5.64941,
    y1: -0.00927879,
    x2: -0.136273,
    y2: 0.154203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitRiskManagement3);
export default __webpack_public_path__ + "static/media/icon-benefit--risk-management3.1f980a5625c87bb6b1c9f08a756c9179.svg";
export { ForwardRef as ReactComponent };